import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCParametros } from "../../infrastructure/services/api/SVCParametros";
import IViewPanelesAlumno from "../../presentation/view-interfaces/IViewPanelesAlumno";
import IViewParametros from "../../presentation/view-interfaces/IViewParametros";
import IViewCombo from "../../presentation/view-interfaces/IViewCombo";
import IViewParametrosMatricula from "../../presentation/view-interfaces/IViewParametrosMatricula";

export const ObtieneParametros = (selListaParametros: any, codigoParametro: string) => {
    let list: Array<IViewParametros> = [];
    SVCParametros.ObtieneParametros(codigoParametro).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: IViewParametros) => {
                list.push({
                    sValor: (e.sValor === null ? '' : e.sValor),
                    nValor: (e.nValor === null ? 0 : e.nValor),
                    dValor: (e.dValor === null ? '' : e.dValor)
                });
            })

            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};
export const ObtieneParametrosP = (selListaParametros: any, rut: string,codCarrera: string) => {
    let list: Array<IViewParametros> = [];
    SVCParametros.ObtieneParametrosPago(rut,codCarrera).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: IViewParametros) => {
                list.push({
                    sValor: (e.sValor === null ? '' : e.sValor),
                    nValor: (e.nValor === null ? 0 : e.nValor),
                    dValor: (e.dValor === null ? '' : e.dValor)
                });
            })
            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });

};


export const ObtieneDias = (selListaParametros: any, codigoParametro: string, mes: string) => {
    let list: Array<IViewParametros> = [];
    SVCParametros.ObtieneDias(codigoParametro, mes).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            //console.log(data);
            data.map((e: IViewParametros) => {
                list.push({
                    sValor: (e.sValor === null ? '' : e.sValor),
                    nValor: (e.nValor === null ? 0 : e.nValor),
                    dValor: (e.dValor === null ? '' : e.dValor)
                });
            })

            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtieneProcesoActual = (selListaParametros: any) => {
    let list: any = [];
    SVCParametros.ObtieneProcesoActual(1).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaParametros(false, '', data);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtienePanelesTipoPersonaValidar = (selListaPaneles: any, codigoNegocio: number) => {
    let list: Array<IViewPanelesAlumno> = [];
    SVCParametros.ObtienePanelesTipoPersonaValidar(codigoNegocio).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            for (let i = 0; i < data.length; i++) {
                list.push({
                    idTipoPersona: data[i].idTipoPersona,
                    descripcionTipo: data[i].descripcionTipo,
                    estado: data[i].estado,
                    mwPersonaNegocio: data[i].mwPersonaNegocio
                });

            }

            selListaPaneles(false, '', list);
        } else {
            selListaPaneles(true, res.errorDetails, list);
        }
    });
};

export const ObtieneBancosActual = (selListaParametros: any) => {
    let list: Array<IViewCombo> = [];
    SVCParametros.ObtieneBancosActual(1).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                if (e.estado) {
                    list.push({ ID: e.codigoBanco, descripcion: e.nombre })
                }
            })

            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtieneCuentasActual = (selListaParametros: any) => {
    let list: Array<IViewCombo> = [];
    SVCParametros.ObtieneCuentasActual().then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                if (e.estado) {
                    list.push({ ID: e.idTipoCuenta, descripcion: e.nombreTipoCuenta })
                }
            })
            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtenerMonedas = (selListaParametros: any) => {
    let list: Array<IViewCombo> = [];
    SVCParametros.ObtenerMonedas(1).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                if (e.estado) {
                    list.push({ ID: e.moneda, descripcion: e.abreviacion })
                }
            })
            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtenerPariedad = (selListaParametros: any, data: number, fecha: string) => {
    let list: number = 1;
    SVCParametros.ObtenerPariedad(data, fecha).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            list = data.paridad;
            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};

export const ObtieneMensajeBloqueoAcceso = (selMensajeBloqueoAcceso: any) => {
    let list: boolean = false;
    SVCParametros.ObtieneMensajeBloqueoAcceso().then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selMensajeBloqueoAcceso(false, '', data);
        } else {
            selMensajeBloqueoAcceso(true, res.errorDetails, list);
        }
    });
};

export const ObtieneParametrosBool = (selListaParametros: any, codigoParametro: string) => {
    let list: Array<IViewParametrosMatricula> = [];
    SVCParametros.ObtieneParametrosBool(codigoParametro).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: IViewParametrosMatricula) => {
                list.push({
                    sVALOR: (e.sVALOR === null ? '' : e.sVALOR),
                    nVALOR: (e.nVALOR === null ? 0 : e.nVALOR),
                    dVALOR: (e.dVALOR === null ? '' : e.dVALOR),
                    lVALOR: (e.lVALOR === null ? false : e.lVALOR)
                });
            })

            selListaParametros(false, '', list);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });
};